import React from 'react';
import { compose } from 'redux';

import {
  cloneDeep, findIndex, orderBy, keys, values, transforms
} from 'lodash';

import { LinkContainer } from 'react-router-bootstrap';

import * as Table from 'reactabular-table';
import * as search from 'searchtabular';
import * as sort from 'sortabular'; 
import * as resizable from 'reactabular-resizable';
import * as resolve from 'table-resolver';
import * as edit from 'react-edit'; 
 
import { Row, Col, Panel, DropdownButton, MenuItem, Tooltip, OverlayTrigger, Button}  from 'react-bootstrap';

import VisibilityToggles from 'react-visibility-toggles';

import {
  Paginator, PrimaryControls, generateRows, paginate
} from '../tableHelpers';

import {analyseState, analyseState2, getError, generateStateColumn, isActivated, createStateColumn, getStateSummary} from 'utils/analyseState';
import { MobileCardList, MobileCard } from '../common/MobileCard';


var elevator = require('../../../static/img/elevator.png')
var escalator = require('../../../static/img/escalator.png')

import {DeleteButton, ProductHistory} from 'components';

import _ from 'underscore'
 
require('./productTable.css')

var MobileDetect = require('mobile-detect');
import * as ProductActions from 'redux/modules/products';

import { routeActions } from 'react-router-redux';


import {bindActionCreators} from 'redux';


import { connect } from 'react-redux';

import { translate } from 'react-i18next';

@translate(['common'])
@connect(
  state => ({
    query: state.products.query,
    sortingColumns: state.products.sortingColumns,
    pagination : state.products.pagination
  }),

  dispatch=>bindActionCreators({...routeActions, ...ProductActions}, dispatch)
  
)
 


export default class ProductList2 extends React.Component {
  constructor(props) {
    super(props);
    var rows = this.props.products?this.props.products:[];
    var cols = this.getColumns()
    
    rows = rows.map((p)=>{
      p['state_color'] = createStateColumn(p)
      return p
    })

    


    this.state = {
      rows,
      searchColumn: 'all',
      query: props.query||{}, // search query
      sortingColumns: props.sortingColumns, // reference to the sorting columns
      selectedColumn:props.selectedColumn,
      columns: cols, // initial columns
      initialCols:cols,
      pagination: props.pagination,
      isPhone:false
    };

    this.onRow = this.onRow.bind(this);
    this.onRowSelected = this.onRowSelected.bind(this);
    this.onColumnChange = this.onColumnChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onPerPage = this.onPerPage.bind(this);
    this.onToggleColumn = this.onToggleColumn.bind(this);
    this.showHistory = this.showHistory.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);

    this.getColumns = this.getColumns.bind(this);
  }
  
  
  
  showHistory(id) {
  	
  	var display = document.getElementById(id).style.display
  	
  	if( display == 'block' ) {
  		document.getElementById(id).style.display = 'none'
  	} else {
  		document.getElementById(id).style.display = 'block'
  	}

  }
  
  
    updateDimensions() {
      var md = new MobileDetect(window.navigator.userAgent);
      
       
      if( md.tablet() || md.phone() ) {
        var cols = this.state.columns; 
        
        cols = cols.map((c)=>{
          if(['etat', 'identification_NUM_ASC', 'actions', 'identification_GSM'].indexOf(c.property) > -1 ) { 
              return {...c, visible:true}
          } else {
              return {...c, visible:false}
           
          } 
        })
        
        if( this.state.isPhone == false  ) {
            this.setState({columns:cols, expanded:false, isPhone:true})
        }
        
        
     } else {
         
         if( this.state.isPhone == true  ) {
             this.setState({columns:this.state.initialCols, expanded:true, isPhone:false})
         }
     }
      
  } 
  
  componentDidMount(){
    window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions()
  } 

  componentDidUpdate(prevProps, prevState){
    if (prevProps.products !== this.props.products) {
      var rows = this.props.products ? this.props.products : [];

      rows = rows.map((p) => {
        p['state_color'] = createStateColumn(p)
        return p
      })

      this.setState({rows, cols:this.getColumns()}) 
      this.updateDimensions();
    }
  }
  
  
  getProductPaths(rowData) {
    const { user, params } = this.props

    var editProductPath, supPath;

    var idArray = [rowData.identification_ID]
    if( rowData.FFID > 0 ) {
      idArray.push(rowData.FFID)
    }
    if( rowData.masterIDPTU != null ) {
      idArray.push(rowData.masterIDPTU)
    }
    var idList = idArray.join(',')

    if( user.role == 'admin' ) {
      editProductPath = '/'+params.role+'/'+params.id+'/product/'+rowData.id+'/edit'
      supPath = '/'+params.role+'/supervision/'+params.id+'/?id='+idList+'&pid='+rowData.id
    } else if(user.role.indexOf('client') > -1 || user.role == 'demo') {
      editProductPath = '/client/product/'+rowData.id+'/edit'
      supPath = '/client/supervision/?id='+idList+'&pid='+rowData.id
    } else {
      editProductPath = '/user/product/'+rowData.id+'/edit'
      supPath = '/user/supervision/?id='+idList+'&pid='+rowData.id
    }

    return { editProductPath, supPath }
  }

  openProductTab(rowData, tab, basic) {
    this.props.expandTabs(tab, true)
    this.props.expandBasicTabs(tab, basic)
    this.props.push(this.getProductPaths(rowData).editProductPath)
  }

  renderMobileCards(rows) {
    const { t } = this.props

    return (
      <MobileCardList empty={t("productList.no_products")}>
        {rows.map((rowData) => {
          const { supPath } = this.getProductPaths(rowData)
          const state = getStateSummary(rowData)
          const typeLabel = rowData.identification_type == 'EM' ? t("main.mecanic_stairs")
            : rowData.identification_type == 'ASC-IP' ? 'Ascenseur CAN-IP'
            : rowData.identification_type == 'ASC' ? 'Ascenseur' : rowData.identification_type

          return (
            <MobileCard
              key={rowData.id}
              className={'mobile-card-' + stateCardColor(state.color)}
              onClick={() => this.openProductTab(rowData, 1, true)}
              title={rowData.identification_NUM_ASC || t("main.non_renseigne")}
              badge={generateStateColumn(rowData)}
              subtitle={[rowData.localisation_adresse, rowData.localisation_ville].filter(Boolean).join(', ') || t("main.non_renseigne")}
              fields={[
                { label: t("main.state"), value: state.error || state.label },
                { label: t("main.identity"), value: rowData.identification_ID },
                { label: 'GSM', value: rowData.identification_GSM },
                { label: 'Type', value: typeLabel },
              ]}
              actions={[
                <Button key="bilan" bsStyle="warning" bsSize="sm" onClick={() => this.openProductTab(rowData, 2000, false)}>
                  <i className="fa fa-line-chart"/> {t("main.bilan")}
                </Button>,
                <Button key="sup" bsStyle="primary" bsSize="sm" onClick={() => this.props.push(supPath)}>
                  <i className="fa fa-eye"/> {t("main.supervision")}
                </Button>,
                isTestLiftAvailable(rowData) &&
                  <Button key="testlift" bsStyle="success" bsSize="sm" onClick={() => this.openProductTab(rowData, 2001, false)}>
                    <i className="fa fa-arrows-v"/> {t('productForm.test_lift')}
                  </Button>
              ]}
            />
          )
        })}
      </MobileCardList>
    )
  }

  getColumns = () => {
  	
  	var self = this;

    const {t} = this.props
    
    const sortable = sort.sort({
      getSortingColumns: () => this.state.sortingColumns || [],

      onSort: selectedColumn => {

        var sortingColumns = sort.byColumns({ sortingColumns: this.state.sortingColumns, selectedColumn})
        this.setState({
          sortingColumns
        })

        this.props.storeSorting(sort.byColumns({ sortingColumns: this.state.sortingColumns, selectedColumn}))

        
      }
    });
     
    const sortableHeader = sortHeader(sortable, () => this.state.sortingColumns);
   

    var {pushState, dispatch} = this.props

    var columns =  [
    	
    	/*{
	        property: 'addr_id',
	        header: {
	          label: 'addr_id',
	          props: {
	            className: "col-md-1"
	          }
	        },
	        visible: true
      },*/
      
      {
        property: 'identification_type',
        header: {
          label: 'Type',
          formatters :  [(v, extra) => sortableHeader(v, extra)],
          props: {
            className: "col-md-1"
          }
        },
        cell: {
          formatters: [
            (value, { rowData }) => {
              if( rowData.identification_type == 'ASC' || rowData.identification_type == 'ASC-IP') { 
                var picto =  elevator
                var pictoTitle = rowData.identification_type == 'ASC-IP' ? "Ascenseur CAN-IP" : "Ascenseur"
              } else if( rowData.identification_type == 'EM' ) {
                var picto = escalator
                var pictoTitle = t("main.mecanic_stairs")
              } else {
                var picto = false
              }
              
              if( picto ) {
                return (<span><img title={pictoTitle} width="50" src={picto}/></span>) 
              } else {
                return <span/>
              }

            }
          ]
        },
         
        visible: true,
        filterable:false,
      }, 
	    /*
	    {
        header: {
          property:'identification_type',
          label: 'Type',
          formatters :  [(v, extra) => sortableHeader(v, extra)],
          props: {
            className: "col-md-1"
          },
          filterable:true, 
          visible: true,
         
        },
        
        cell: {
          formatters: [
            (value, { rowData }) => {
              return rowData.identification_type
              if( rowData.identification_type == 'ASC') { 
                var picto =  elevator
                var pictoTitle = "Ascenseur"
              } else if( rowData.identification_type == 'EM' ) {
                var picto = escalator
                var pictoTitle = "Escalier mécanique"
              } else {
                var picto = false
              }
              
              if( picto ) {
                return (<span><img title={pictoTitle} width="50" src={picto}/></span>) 
              } else {
                return <span/>
              }

            }
          ]
        },
        visible: true
      },*/
	    
 
       
    	{
        property: 'state_color',
        header: {
          label: t("main.state"),
          formatters :  [(v, extra) => sortableHeader(v, extra)],
          props: {
            className: "col-md-1"
          },
        },
        
        cell: {
          formatters: [
            (value, { rowData }) => {
            	return (<span>{generateStateColumn(rowData)}</span>)

            }
          ],
          
        },
        visible: true,
        filterable:false,
      },
      
      
      {
        property: 'identification_NUM_ASC',
        header: {
          label: t("main.num_install"),
          formatters :  [(v, extra) => sortableHeader(v, extra)],
          props: {
            className: "col-md-1"
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {
        		return !value ? t("main.non_renseigne"):value
        		   
        	},search.highlightCell
          	
          	
          ]
        },
         
        visible: true
      }, 
      
      
      {
        property: 'identification_ID',
        header: {
          label:  t("main.identity"),
          formatters :  [(v, extra) => sortableHeader(v, extra)],
          props: {
            className: "col-md-1"
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {
        		return !value ?  t("main.non_renseigne"):value
        		   
        	},search.highlightCell
          	
          	
          ]
        },
        visible: true
      },
      {
        property: 'localisation_adresse',

        filterable:true,
        header: {
          label:  t("main.address"),
          formatters :  [(v, extra) => sortableHeader(v, extra)],
          props: {
            style: {width: '150px'}
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {
        		return !value ?  t("main.non_renseigne"):value
        		   
        	}, search.highlightCell
          	 
          	
          ]
        },
        visible: true
      },
      
      {
        property: 'localisation_ville',
        header: {
          label:  t("main.city"),
          formatters :  [(v, extra) => sortableHeader(v, extra)],
          props: {
            style: {width: '100px'}
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {
        		return !value ?  t("main.non_renseigne"):value
        		   
        	},search.highlightCell
          	
          	
          ]
        },
        visible: true
      },
      /*
      {
        property: 'localisation_prestataire',
        header: {
          label: 'Prestataire',
          formatters :  [(v, extra) => sortableHeader(v, extra)],
          props: {
            className: "col-md-1"
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {
        		return !value ? :value
        		   
        	},search.highlightCell
          	
          	
          ]
        },
        visible: true
      },*/
      
      {
        property: 'identification_GSM',
        header: {
          label: 'GSM',
          formatters :  [(v, extra) => sortableHeader(v, extra)],
          props: {
            style: {width: '90px'}
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {
        		return !value ?  t("main.non_renseigne"):value
        		   
        	},search.highlightCell
          	
          	
          ]
        },
        visible: true
      },
      
      {
        property: 'identification_NUM_MOD',
        header: {
          label: 'Module',
          formatters :  [(v, extra) => sortableHeader(v, extra)],
          props: {
            style: {width: '70px'}
          }
        },
        cell: {
          formatters: [search.highlightCell] 
        },
        visible: true
      }, 
       
      {
        header: {
          label:  t("main.fond_fosse2"),
          formatters :  [(v, extra) => sortableHeader(v, extra)],
          props: {
            className: "col-md-1"
          }
        },
        
        filterable:true,
        cell: {
          formatters: [
            (value, { rowData }) => {
            	
            	var user = self.props.user;
            	var params = self.props.params;
            	
            	var editProductPath = user.role == 'admin' ?
            			'/'+params.role+'/'+params.id+'/product/'+rowData.FF+'/edit' :
            			'/client/product/'+rowData.FF+'/edit';

            	var id= "num_mod"+rowData.id
            	
            	var num_mod_select = 
            		(<span> Num mod &nbsp;
	            	<select id={id}>
	            		<option value="1">1</option>
	            		<option value="2">2</option>
	            		<option value="3">3</option>
	            		<option value="4">4</option>
	            		<option value="5">5</option>
	            		<option value="6">6</option>
	            		<option value="7">7</option>
	            		<option value="8">8</option> 
	            	</select>
	            	</span>
	            	)
	            	

            	var editBtn = rowData.identification_fosse == -1 && rowData.identification_fosse != null  ? 
            			<span>
            			<LinkContainer to={editProductPath}>
            			
				            <button className="btn btn-primary btn-xs">
				              <i className="fa fa-pencil"/> 
                      { t("main.edit_pit") }
				            </button>
				            
			            </LinkContainer> 
			            <DeleteButton  ctext="Confirmer" size="xs" callback={()=> {
		  			  			self.props.handlePit(params, {product:rowData}, false, true)
			          }} /></span> : <span><button onClick={()=>{
		  			  			
		  			  			var e = document.getElementById(id);
										var value = e.options[e.selectedIndex].value;
										rowData.identification_NUM_MOD = value;

										self.props.handlePit(params, {product:rowData}, false, false)
										return
		
	  			  		}} className="btn btn-success btn-xs">
	              <i className="fa fa-plus-circle"/> { t("main.add_pit")}
		            </button> <br/>{num_mod_select}</span>
			          
            
            	//return (<span>{editBtn}</span>)
            	
            	var res = rowData.identification_fosse == -1 ? 1 : 0 
            	
            	return (<span>{res}</span>)

            }
          ]
        },
        visible: true
      }

    ];
    
    
  	columns.push(
    {
      property:'actions',
    	header: {
        label: 'Actions',
        props: {
          style: {width: '180px'}
        }
      },
      filterable: false,
    	
      cell: {
        formatters: [(value, { rowData }) => {
        	var user = self.props.user;
        	var params = self.props.params;

          var { editProductPath, supPath } = self.getProductPaths(rowData)

        	var callb = self.props.handleDelete(rowData, params)
        	var state = analyseState(rowData.s_etat)
        	var is_disabled = false;
        	

        	if( rowData.identification_NUM_MOD == 1 ) {
        		if( state.asts1.state == 3 || state.aspr1.state == 3 || rowData.siblings > 0 || rowData.FF) {
        			is_disabled = true;
        		} else {
        			is_disabled = false;
        		}
        	} else {
        		
        		is_disabled = false
        	}
        	
        	
        	if( rowData.identification_NUM_MOD == 1 ) {
        		var disableMsg = is_disabled ?  t("productList.deactivate_sync1") :  t("productList.warning_history1")
        	} else {
        		var disableMsg = is_disabled ?  t("main.deactivate_sync2") :  t("productList.warning_history2")
        	}
        	
        	var disableMsg = is_disabled ?  t("main.deactivate_sync1"):  t("productList.warning_history1")

          /*var idList = idArray.join(',')
          if( user.role == 'admin' ) {
            supPath = '/'+params.role+'/supervision/'+params.id+'/?id='+rowData.id+'&pid='+rowData.id
          } else if(user.role.indexOf('client') > -1 || user.role == 'demo') {
            supPath = '/client/supervision/?id='+rowData.id+'&pid='+rowData.id
          } else {
            supPath = '/user/supervision/?id='+rowData.id+'&pid='+rowData.id
          }*/

           
          var supBtn = (
              <LinkContainer to={supPath}>
		            <Button bsStyle='primary' bsSize="sm">
		              <i className="fa fa-eye"/>
		            </Button> 
		          </LinkContainer>
				  );
							         
          const tooltip1 = (
            <Tooltip id="tooltip">
              <strong>{ t("main.edit_sheet")}</strong>
            </Tooltip>
          );
		          
          const tooltip2 = (
        		<Tooltip id="tooltip">
        			<strong>{ t("main.supervision_entries")}</strong>
        		</Tooltip>
          );
          
          const tooltip3 = (
        		<Tooltip id="tooltip">
        			<strong>{ t("main.bilan")}</strong>
        		</Tooltip>
          );
          const tooltip6 = (
	        		<Tooltip id="tooltip">
	        			<strong>{ t("main.disponibility")}</strong>
	        		</Tooltip>
	          );
          
          const tooltip4 = (
        		<Tooltip id="tooltip">
        			<strong>{ t("main.sync_history")}</strong>
        		</Tooltip>
          );
          
          const tooltip5 = (
        		<Tooltip id="tooltip">
        			<strong>{ t("main.delete_sheet")}</strong>
        		</Tooltip>
          );
          
          const tooltipTestLift = (
        		<Tooltip id="tooltip">
        			<strong>{t('productForm.test_lift')}</strong>
        		</Tooltip>
          );
          
          var current_actions = [];
          
          if( self.props.smsActions ) {
	          if( rowData.s_id in self.props.smsActions ) {
	          	
	          	_.each(self.props.smsActions[rowData.s_id], (action)=>{
	          		if( action.intervalLaunched ) {
		          		current_actions.push(<div>{action.label} <i className="fa fa-refresh fa-spin"/></div>)
		          	}
	          	})
	          	
	          	
	          }
          }
          
          
          if( this.state.isPhone ) {
            var menu = (
              
              <DropdownButton
                title={'Actions'}
                key={'12'}
              > 
                <MenuItem eventKey="2">
                  <LinkContainer to={editProductPath}><span>{ t("main.edit_sheet")}</span></LinkContainer>
                </MenuItem>
                <MenuItem eventKey="2">
                  <LinkContainer to={editProductPath+'?dispo=1'}><span>{ t("main.bilan")}</span></LinkContainer>
                </MenuItem>
              
                 <MenuItem eventKey="4">
                   <LinkContainer to={supPath}><span>{ t("main.supervision")}</span></LinkContainer>
                </MenuItem>

                {isTestLiftAvailable(rowData) &&
                  <MenuItem eventKey="5" onClick={()=>{
                    self.props.expandTabs(2001, true)
                    self.props.expandBasicTabs(2001, false)
                    self.props.push(editProductPath)
                  }}>
                    <span>{t('productForm.test_lift')}</span>
                  </MenuItem>
                }

            </DropdownButton>
            )
          } else {
            
            var menu = (
              <div style={{position:'relative', width:'180px', whiteSpace:'nowrap'}}>
                <OverlayTrigger placement="top" overlay={tooltip1} >
                    <Button bsStyle='primary' bsSize="sm" onClick={()=>{                      
                      
                      self.props.expandTabs(1, true)
                      self.props.expandBasicTabs(1, true)
                      self.props.push(editProductPath)
                    }}>
                      <i className="fa fa-pencil"/>
                    </Button>
                </OverlayTrigger>
                &nbsp;
                
                <OverlayTrigger placement="top" overlay={tooltip3}>
                    <Button bsStyle='warning' bsSize="sm" onClick={()=>{                      
                      
                      self.props.expandTabs(2000, true)
                      self.props.expandBasicTabs(2000, false)
                      self.props.push(editProductPath)
                    }}>
                      <i className="fa fa-line-chart"/>
                      
                    </Button>
                </OverlayTrigger>
                &nbsp;

               { /*<OverlayTrigger placement="top" overlay={tooltip6}>
                  <LinkContainer to={editProductPath+'?dispo=1'}>
                    <Button bsStyle='warning' bsSize="sm">
                      <i className="fa fa-line-chart"/>
                    </Button>
                  
                  </LinkContainer>
                </OverlayTrigger>
            &nbsp; */}

                <OverlayTrigger placement="top" overlay={tooltip2}>
                  {supBtn}
                </OverlayTrigger>
                &nbsp;
                
                <OverlayTrigger placement="top" overlay={tooltip4}>
                  <Button bsStyle='info' bsSize="sm" onClick={()=>{this.showHistory("phistory_"+rowData.id)}}>
                    <i className="fa fa-history"/>
                  </Button>
                </OverlayTrigger>
                
                &nbsp;
                
                {isTestLiftAvailable(rowData) &&
                  <OverlayTrigger placement="top" overlay={tooltipTestLift}>
                    <Button bsStyle='success' bsSize="sm" onClick={()=>{
                      self.props.expandTabs(2001, true)
                      self.props.expandBasicTabs(2001, false)
                      self.props.push(editProductPath)
                    }}>
                      <i className="fa fa-arrows-v"/>
                    </Button>
                  </OverlayTrigger>
                }
                
                &nbsp;
                
                {(this.props.user.role != 'user' || this.props.user.super_user == true) &&
                  
                  <OverlayTrigger placement="top" overlay={tooltip5}>
                    <DeleteButton  size='sm' ctext="Confirmer"
                      disableMsg={disableMsg}
                      disabled={is_disabled } callback={callb}
                    />
                  </OverlayTrigger>
                }
                
                {/*current_actions*/}
                
                <div style={{display:'none'}}  id={"phistory_"+rowData.id}>
                  <ProductHistory product={rowData}/>
                </div>
                

             </div>
                
            )
            
          }
                
          return menu

        }]
      },
      visible: true
    })
    	
    	
    
    
    return columns;
    
    
  }
  render() {

    const {t} = this.props
    const {
       rows, pagination, sortingColumns, searchColumn, query
    } = this.state;

    var columns = this.getColumns()
    
    const cols = columns.filter(column => column.visible);
    
    var newRows = rows.filter((r)=>{
      return (r.identification_fosse < 1 || r.identification_fosse == null)
    })
    
    
    const paginated = compose(
      paginate(pagination),
      sort.sorter({ columns: cols, sortingColumns, sort: orderBy }),
      search.highlighter({ columns: cols, matches: search.matches, query }),
      search.multipleColumns({ columns: cols, query }),
      resolve.resolve({
        columns: cols,
        method: ({ rowData, column }) => resolve.byFunction('cell.resolve')({
          rowData: resolve.nested({ rowData, column }),
          column
        })
      })
    )(newRows);
    
    
    return (
      <div>
        {/*<VisibilityToggles
          columns={columns}
          onToggleColumn={this.onToggleColumn}
        />*/}
        
        
        {/*
        <Row>
          <Col xs={12} md={6}>
            <Panel collapsible header="Affichage">
              
                <VisibilityToggles
                  columns={columns}
                  onToggleColumn={this.onToggleColumn}
                />
              
              
            </Panel>
                
           </Col>
        </Row>*/}

        <PrimaryControls
          className="controls"
          perPage={pagination.perPage}
          column={searchColumn}
          query={query}
          columns={cols}
          rows={rows}
          onPerPage={this.onPerPage}
          onColumnChange={this.onColumnChange}
          onSearch={this.onSearch}
          pageProducts
          t={t}
        />


        
        
        {this.renderMobileCards(paginated.rows)}

        <div className="table-responsive hidden-xs"> 
	        <Table.Provider
	          className="table table-striped"
	          columns={this.getColumns()}
	          style={{ overflowX: 'auto' }}
	        	ref="table"
	        >
	          <Table.Header>
	             <search.Columns query={query} columns={cols} onChange={this.onSearch} /> 
	          </Table.Header>
	
	          <Table.Body onRow={this.onRow} rows={paginated.rows} rowKey="id" />
	
	          {/*<CustomFooter columns={cols} rows={paginated.rows} />*/}
	        </Table.Provider> 
        
        </div>
        
        <div className="controls">
          <Paginator
            pagination={pagination}
            pages={paginated.amount}
            onSelect={this.onSelect}
            prevText={t("pagination.previous")}
            nextText={t("pagination.next")}
          />
        </div>

      </div>
    );
  } 
  onRow(row, { rowIndex }) {
    return {
      onClick: () => this.onRowSelected(row)
    };
  }
  onRowSelected(row) {
  }
  onColumnChange(searchColumn) {
    
    this.setState({
      searchColumn
    });
  }
  onSearch(query) {

    this.props.storeQuery(query)
    
    this.setState({
      query
    });
  }
  onSelect(page) {
    const pages = Math.ceil(
      this.state.rows.length / this.state.pagination.perPage
    );

    var pagination = {
      ...this.state.pagination,
      page: Math.min(Math.max(page, 1), pages)
    }

    this.setState({
      pagination
    });

    this.props.storePagination(pagination)
  }
  onPerPage(value) {
    var pagination = {
      ...this.state.pagination,
      perPage: parseInt(value, 10)
    }

    this.setState({
      pagination
    });

    this.props.storePagination(pagination)

  }
  
  onToggleColumn(columnIndex) {
    const columns = cloneDeep(this.state.columns);
    const column = columns[columnIndex];
    column.visible = !column.visible;
    const query = cloneDeep(this.state.query);
    delete query[column.property];
    this.setState({ columns, query });
  }
}




function isTestLiftAvailable(rowData) {
  if ((rowData.identification_type !== 'ASC-IP' && rowData.identification_type !== 'ASC') || !rowData.equipsn_last_notify) {
    return false
  }
  var hoursSinceNotify = (new Date() - new Date(rowData.equipsn_last_notify)) / (1000 * 60 * 60);
  return hoursSinceNotify <= 24;
}

function stateCardColor(color) {
  switch (color) {
    case '#00FF00': case 'green': return 'green'
    case 'orange': return 'orange'
    case 'red': return 'red'
    case '#0000FF': case 'blue': return 'blue'
    case 'black': return 'black'
    default: return 'grey'
  }
}

const CustomFooter = ({ columns, rows }) => {
  return (
    <tfoot>
      <tr>
        {columns.map((column, i) =>
          <td key={`footer-${i}`}>{column.footer ? column.footer(rows) : null}</td>
        )}
      </tr>
    </tfoot>
  );
}

function sortHeader(sortable, getSortingColumns) {
  return (value, { columnIndex }) => {
    const sortingColumns = getSortingColumns() || [];

    return (
      <div style={{ display: 'inline' }}>
        <span className="value">{value}</span>
        {React.createElement(
          'span',
          sortable(
            value,
            {
              columnIndex
            },
            {
              style: { float: 'right' }
            }
          )
        )}
        {sortingColumns[columnIndex] &&
          <span className="sort-order" style={{ marginLeft: '0.5em', float: 'right' }}>
            {sortingColumns[columnIndex].position + 1}
          </span>
        }
      </div>
    );
  };
}
        
        
        

